import { ClassAttributes, createElement, FC } from 'react';

import RouteLifecycleWrapper from '../component/primitive/RouteLifecycleWrapper';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as HistoryConsumer } from '../context/history';
import { Consumer as StateConsumer } from '../context/state';
import _OffersListPage from '../page/OffersListPage';

type Props = ClassAttributes<HTMLElement>;

const OffersListPage: FC<Props> = () => (
  <DependencyConsumer>
    {(dependency) => (
      <HistoryConsumer>
        {(_history) => (
          <StateConsumer>
            {(state) => {
              return (
                <RouteLifecycleWrapper
                  onMount={async () => {
                    dependency.authenticationUsecase.needSignedIn();
                    await dependency.listOfferUsecase.prepare();
                  }}
                  onUnmount={() => dependency.listOfferUsecase.disposeOffers()}
                >
                  <_OffersListPage
                    offers={state.offers.items}
                    loading={state.offers.fetching >= 1}
                    hasNextPage={state.offers.nextCursor != null}
                    onRequestLoadMore={async () => {
                      await dependency.listOfferUsecase.loadMore();
                    }}
                    onChangeFlag={async (_: any, isHideClosedOffer: boolean) => {
                      await dependency.listOfferUsecase.changeIsHideClosedOffer(!isHideClosedOffer);
                    }}
                    language={state.language}
                    isHideClosedOffer={state.offers.isHideClosedOffer}
                  />
                </RouteLifecycleWrapper>
              );
            }}
          </StateConsumer>
        )}
      </HistoryConsumer>
    )}
  </DependencyConsumer>
);

export default OffersListPage;
